import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import menu from "../assets/menu.png";
import verifiedWhite from "../assets/verified-white.svg";
import penyelenggara from "../assets/penyelenggara-sertifikat-elektronik.png";
import search from "../assets/search.png";
// import translate from '../assets/translate.png';
import defaultUser from "../assets/default-user.png";
import { http, baseURL } from "../misc/http";
import history from "../misc/history";
import RunningText from './Home/RunningText'
import Navbar from "./Navbar";

export default class SideNav extends Component {
  state = {
    dropDownInformasi: "",
    dropDownKegiatan: "",
    dropDownUser: "",
    user: {},
    profiles: {},
    isLogin: false,
  };

  handleDropDownInformasi = () => {
    this.setState({
      dropDownInformasi: this.state.dropDownInformasi === "" ? "show" : "",
      dropDownKegiatan: "",
      dropDownUser: "",
    });
  };

  handleDropDownKegiatan = () => {
    this.setState({
      dropDownKegiatan: this.state.dropDownKegiatan === "" ? "show" : "",
      dropDownInformasi: "",
      dropDownUser: "",
    });
  };

  handelDropDownUser = () => {
    this.setState({
      dropDownUser: this.state.dropDownUser === "" ? "show" : "",
      dropDownInformasi: "",
      dropDownKegiatan: "",
    });
  };

  getLocalData = async () => {
    let user = JSON.parse(localStorage.getItem("kominfo-psre"));
    if (user !== null) {
      this.setState({ user: user ? user : {}, isLogin: user ? true : false });
      let params = {
        method: "GET",
        path: "profiles/" + user.email,
        token: user.token,
        showMessage: false,
      };
      let { data } = await http(params);
      if (data.status === true && data.code === 200) {
        this.setState({ profiles: data.data, user: user });
      } else {
        this.setState({ user: user, profiles: {} });
      }
    }
  };


  componentDidMount = () => {
    this.getLocalData();
    document.addEventListener("click", this.handleClickOutside, true);
  };

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
  }

  handleClickOutside = (event) => {
    const domNode = ReactDOM.findDOMNode(this);

    if (!domNode || !domNode.contains(event.target)) {
      this.setState({
        dropDownInformasi: "",
        dropDownKegiatan: "",
        dropDownUser: "",
      });
    }
  };

  handleLogout = () => {
    localStorage.removeItem("kominfo-psre");
    this.setState({ user: {}, isLogin: false });
    history.push("/");
  };

  renderLogin = () => {
    return this.state.isLogin ? (
      <li
        className={`nav-item dropdown ${this.state.dropDownUser}`}
        onClick={() => this.handelDropDownUser()}
      >
        <div className="dropdown">
          <a
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded={this.state.dropDownUser === "" ? "false" : "true"}
            style={{ color: "black" }}
          >
            <span className="mr-3 ml-3" style={{ fontSize: "14px" }}>
              Profil
            </span>
            <img
              className="rounded-circle"
              src={
                this.state.profiles.picture
                  ? baseURL + this.state.profiles.picture
                  : defaultUser
              }
              alt="mar"
              style={{ width: "35px", height: "35px", objectFit: "cover" }}
            />
            <span className="ml-3 mt-3">
              <i className="fas fa-caret-down"></i>
            </span>
          </a>
          <div
            className={`dropdown-menu dropdown-menu-right ${this.state.dropDownUser}`}
            aria-labelledby="dropdownMenuLink"
          >
            <a
              className="dropdown-item"
              href="/profiles"
              style={{ color: "black" }}
            >
              Akun Saya
            </a>
            {/* <a className="dropdown-item" href="./kegiatan-acara-saya.html" style={{color: 'black'}}>Kegiatan Acara Saya</a> */}
            <a
              className="dropdown-item logout"
              href="#"
              style={{ color: "black" }}
              onClick={() => this.handleLogout()}
            >
              Logout
            </a>
          </div>
        </div>
      </li>
    ) : (
      <li className="nav-item">
        <Link className="nav-link ind" to="/login" style={{ color: "black" }}>
          Login
        </Link>
      </li>
    );
  };

  render() {
    return <Navbar/>
  //   return (
  //     <>
  //       <nav className="navbar navbar-expand-lg bg-white nav-atas">
  //         <div className="container">
  //           <div className="d-flex">
  //             <Link
  //               className="navbar-brand"
  //               to="/"
  //               style={{ transition: "all 0.2s ease 0s" }}
  //             >
  //               <img
  //                 src={penyelenggara}
  //                 alt="penyelenggara-sertifikat-elektronik"
  //                 style={{ height: "53px", width: "auto" }}
  //               />
  //             </Link>
  //             <div
  //               className="collapse navbar-collapse d-lg-block d-md-none d-sm-none d-none"
  //               id="navbarSupportedContent"
  //             >
  //               <ul className="navbar-nav ml-auto">
  //                 {/* <li className="nav-item">
  //                   <Link
  //                     className="nav-link ind p-nunito"
  //                     to="/"
  //                     style={{ color: "black" }}
  //                   >
  //                     Beranda
  //                   </Link>
  //                 </li> */}
  //                 <li
  //                   className={`nav-item dropdown ${this.state.dropDownInformasi}`}
  //                   onClick={() => this.handleDropDownInformasi()}
  //                 >
  //                   <Link
  //                     className="nav-link dropdown-toggle p-nunito"
  //                     id="navbarDropdown"
  //                     to="#"
  //                     role="button"
  //                     data-toggle="dropdown"
  //                     aria-haspopup="true"
  //                     aria-expanded={
  //                       this.state.dropDownInformasi === "" ? "false" : "true"
  //                     }
  //                   >
  //                     Informasi
  //                   </Link>
  //                   <div
  //                     className={`dropdown-menu ${this.state.dropDownInformasi}`}
  //                     aria-labelledby="navbarDropdown"
  //                   >
  //                     <Link className="dropdown-item p-nunito" to="/apaitu">
  //                       Profil
  //                     </Link>
  //                     <Link className="dropdown-item p-nunito" to="/listPSrE/_">
  //                       Daftar PSrE
  //                     </Link>
  //                     <Link className="dropdown-item p-nunito" to="/lembaga-sertifikat">
  //                       Lembaga Sertifikasi
  //                     </Link>
  //                     <Link
  //                       className="dropdown-item p-nunito"
  //                       to="/requirement"
  //                     >
  //                       Persyaratan PSrE
  //                     </Link>
  //                     <Link className="dropdown-item p-nunito" to="/regulation">
  //                       Regulasi dan Panduan
  //                     </Link>
  //                   </div>
  //                 </li>
  //                 <li
  //                   className={`nav-item dropdown ${this.state.dropDownKegiatan}`}
  //                   onClick={() => this.handleDropDownKegiatan()}
  //                 >
  //                   <Link
  //                     className="nav-link dropdown-toggle p-nunito"
  //                     id="navbarDropdown"
  //                     to="#"
  //                     role="button"
  //                     data-toggle="dropdown"
  //                     aria-haspopup="true"
  //                     aria-expanded={
  //                       this.state.dropDownKegiatan === "" ? "false" : "true"
  //                     }
  //                   >
  //                     Galeri
  //                   </Link>
  //                   <div
  //                     className={`dropdown-menu ${this.state.dropDownKegiatan}`}
  //                     aria-labelledby="navbarDropdown"
  //                   >
  //                     {/* <a className="dropdown-item p-nunito" href="/event/organizer">
  //                       Penyelenggara
  //                     </a> */}
  //                     <a className="dropdown-item p-nunito" href="/event/gallery">
  //                       Kumpulan Video & Galeri
  //                     </a>
  //                     {/* <a className="dropdown-item p-nunito" href="/event/all">
  //                       Kegiatan Acara{" "}
  //                     </a> */}
  //                     {/* <a className="dropdown-item p-nunito" href="/forum">
  //                       Forum Tanya Jawab
  //                     </a> */}
  //                     {/* <a className="dropdown-item p-nunito" href="/event/blog">
  //                       Blog Artikel
  //                     </a> */}
  //                     <a
  //                       className="dropdown-item p-nunito"
  //                       href="/event/infographic"
  //                     >
  //                       Infografik
  //                     </a>
  //                   </div>
  //                 </li>
  //                 <li className="nav-item">
  //                   <Link
  //                     className="nav-link ind p-nunito"
  //                     to="/event/all"
  //                     style={{ color: "black" }}
  //                   >
  //                     Acara & Webinar{" "}
  //                     <span
  //                       style={{
  //                         backgroundColor: "#0093DD",
  //                         padding: "1px 7px",
  //                         fontSize: 10,
  //                         borderRadius: 7.5,
  //                         color: "white",
  //                       }}
  //                     >
  //                       Baru
  //                     </span>
  //                   </Link>
  //                 </li>
  //                 <li className="nav-item">
  //                   <Link
  //                     className="nav-link ind p-nunito"
  //                     to="/event/blog"
  //                     style={{ color: "black" }}
  //                   >
  //                     Berita
  //                   </Link>
  //                 </li>
  //                 {/* {this.renderLogin()} */}
  //                 {/* <li
  //                   className="nav-item"
  //                   style={{ display: "flex", flexDirection: "row" }}
  //                 >
  //                   <a
  //                     href="https://psre.kominfo.go.id"
  //                     target="_blank"
  //                     className="av-link btn-border btn ind"
  //                   >
  //                     Portal PSRE
  //                   </a>
  //                   <Link className="nav-link btn-blue btn ind" to="/verifyPDF">
  //                     Verifikasi PDF
  //                   </Link>
  //                 </li> */}
  //                 {/* <Link className="nav-link btn-blue btn ind" to='/vote' target="_blank" 
  //               >Vote</Link> */}
  //                 {/* <li className="nav-item">
  //                   <Link className="nav-link ind" to="/search">
  //                     <img
  //                       src={search}
  //                       alt=""
  //                       style={{ width: "20px", height: "20px" }}
  //                     />
  //                   </Link>
  //                 </li> */}
  //                 {/* <li className="nav-item">
  //               <Link className="nav-link ind" to="#">
  //                 <img src={translate} alt="" style={{width:'20px', height:'20px'}} />
  //               </Link>
  //             </li> */}
  //               </ul>
  //             </div>
  //           </div>
  //           <div className="d-none d-md-flex" style={{alignItems: 'center'}}>
  //             {/* <Link className="nav-link ind p-nunito" to="/search">
  //               Daftar
  //             </Link> */}
  //             <Link className="nav-link ind p-nunito" to="/login">
  //               Masuk
  //             </Link>
  //             <Link
  //               style={{
  //                 backgroundColor: "#1672BD",
  //                 display: "flex",
  //                 justifyContent: "center",
  //                 alignItems: "center",
  //                 padding: "6px 18px",
  //                 borderRadius : 20,
  //                 cursor: 'pointer'
  //               }}
  //               to="/verifyPDF"
  //             >
  //               <img
  //                 className="mb-0"
  //                 src={verifiedWhite}
  //                 alt="verified"
  //                 style={{
  //                   height: "15px",
  //                   objectFit: "contain",
  //                   marginRight: 2,
  //                 }}
  //               />
  //               <p
  //                 style={{ marginBottom: 0, color: "white" }}
  //                 className="p-nunito"
  //               >
  //                 Verifikasi PDF
  //               </p>
  //             </Link>
  //           </div>
  //         </div>
  //       </nav>
  //     </>
  //   );
  }
}
